<template>
  <v-container>
    <h1>Update Wiki Rating</h1>

    <progress-component script="UpdateWikiRating"></progress-component>
  </v-container>
</template>

<script>
import ProgressComponent from '../components/ProgressComponent.vue';

export default {
  name: 'UpdateWikiRating',
  components: { ProgressComponent },
};
</script>
